// extracted by mini-css-extract-plugin
export var investmentListDesktop = "X63srzcXSY2HYR4pw_22";
export var investmentListMobile = "HYufQ2cyMTbFLn7i8D7L";